module.exports = __webpack_public_path__ + "img/home-3-green.4c6104b4.png";